import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useSelector } from 'react-redux';
import { format, addDays } from 'date-fns';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import 'rc-slider/assets/index.css';

require('dayjs/locale/es');
dayjs.locale('es');

const GuestDataForm = props => {
  const { onSubmitFunction, spaceDetail, lenguage } = props;
  const searchFormData = useSelector(state => state.searchFormData);
  const userData = useSelector(state => state.user);
  const navigate = useNavigate();

  const tomorrow = format(addDays(new Date(), 1), 'yyyy-MM-dd');
  const values = {
    startDate: searchFormData?.startDate ? searchFormData?.startDate : tomorrow,
    startTime: searchFormData?.startTime ? searchFormData?.startTime : '09:00',
    endTime: searchFormData?.endTime ? searchFormData?.endTime : '10:00',
    name: '',
    email: '',
    phone: '',
    countryCode: lenguage === 'EN' ? '+1' : '+52',
    guestQuantyty: searchFormData?.guests ? searchFormData?.guests : 1,
  };

  const onClickButton = values => {
    if (userData) {
      onSubmitFunction(values);
    } else {
      const registerUrl = lenguage === 'ES' ? '/registrarse' : '/signup';
      navigate(registerUrl);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <button
        onClick={() => onClickButton(values)}
        className={'bgPink1 borderNone fontWhite grayShadow16 width100 padtb20'}
      >
        <FlexContainer className={'justify-center'}>
          {userData && (
            <strong className={'text-18'}>
              {lenguage === 'ES' ? 'RESERVA AHORA | ' : 'BOOK NOW | '}{' '}
              {spaceDetail?.formattedPrice}
            </strong>
          )}
          {!userData && (
            <strong className={'text-16'}>
              {lenguage === 'ES'
                ? 'REGISTRATE Y RESERVA | '
                : 'SIGN UP & BOOK | '}{' '}
              {spaceDetail?.formattedPrice}
            </strong>
          )}
        </FlexContainer>
      </button>
    </LocalizationProvider>
  );
};

const ShortReservationDetail = props => {
  const { className, onClick, spaceDetail } = props;
  const lenguage = useSelector(state => state.lenguage?.lang);
  const containerClass = className + ' flex-column fontWhite width100';
  return (
    <FlexContainer className={containerClass}>
      <GuestDataForm
        onSubmitFunction={onClick}
        spaceDetail={spaceDetail}
        lenguage={lenguage}
      />
    </FlexContainer>
  );
};

export default ShortReservationDetail;
